export default {
      id: "lock-usage",
      viewBox: "0 0 13 17",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#lock",
      toString: function () {
        return this.url;
      }
    }